import { render } from "./WeatherChart.vue?vue&type=template&id=0b87a7e5&ts=true"
import script from "./WeatherChart.vue?vue&type=script&lang=ts"
export * from "./WeatherChart.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__